// extracted by mini-css-extract-plugin
export var partner__container = "partner-module--partner__container--ERE7+";
export var partner__link = "partner-module--partner__link--k-5XA";
export var partner__wrapper = "partner-module--partner__wrapper--EzKZ7";